import { connect } from 'react-redux';
import Pagamento from './pagamento';

export default connect()(Pagamento);
